import React from 'react';
import PropTypes from 'prop-types';
import { List, Map } from 'immutable';
import { useSelector } from 'react-redux';
import CardFace from '../Card/CardFace';
import { selectCardsById } from '../Cards/selectors';
import MatLayout from '../Board/MatLayout';
import { isMatTurned } from '../Board/layout';
import { MiniFrame } from './styled';
import { DeckStack } from '../Deck/styled';

/** What's in one of a player's spots, as a picture: the same cards the game shows there, but nothing to tap. */
const pictureSpot = (side, cardsById) => (zone, position) => {
  if (!side) {
    return null;
  }
  const pokemon = (spot) => spot && (
    <CardFace card={spot.get('card_id') ? cardsById.get(spot.get('card_id')) : undefined} damage={spot.get('damage')} />
  );
  switch (zone) {
    case 'prize':
      return side.get('prizes', List()).includes(position) ? <CardFace label="Prize card" /> : null;
    case 'active':
      return pokemon(side.get('active'));
    case 'bench':
      return pokemon(side.get('bench', List()).find(spot => spot.get('position') === position));
    case 'deck':
      return side.get('deck') ? <DeckStack $count={side.get('deck')}><CardFace count={side.get('deck')} /></DeckStack> : null;
    case 'discard':
      return side.get('discard_top') ? <CardFace card={cardsById.get(side.get('discard_top'))} count={side.get('discard')} /> : null;
    default:
      return null;
  }
};

/**
 * A small picture of a game for the games list, laid out exactly like the game's mat (MatLayout): prizes, the active
 * Pokémon, the bench, the deck and the discard pile on both sides, face down where you can't see them yet. The
 * server sends what's there (`board`).
 */
const MiniBoard = ({ game, userId }) => {
  const cardsById = useSelector(selectCardsById);
  const board = game.get('board') || List();
  const mine = board.find(side => side.get('user_id') === userId);
  const theirs = board.find(side => side.get('user_id') !== userId);

  return (
    <MiniFrame aria-hidden="true">
      <MatLayout
        turned={isMatTurned(game, userId)}
        opponentSpot={pictureSpot(theirs, cardsById)}
        playerSpot={pictureSpot(mine, cardsById)}
      />
    </MiniFrame>
  );
};

MiniBoard.propTypes = {
  game: PropTypes.instanceOf(Map).isRequired,
  userId: PropTypes.number,
};

export default MiniBoard;
